import type { PayloadAction, UnknownAction } from '@reduxjs/toolkit';

import type { MessageHandlerResult } from '@/services/abstract/poc/MessagingService';
import {
  incomingMessageReceived,
  type IncomingMessagePayload,
} from '@/store/actions/poc/incomingMessageReceived';

type IncomingMessageType = MessageHandlerResult['type'];

export type IncomingMessageOfType<TType extends IncomingMessageType> =
  IncomingMessagePayload & {
    result: Extract<MessageHandlerResult, { type: TType }>;
  };

export function isIncomingMessageOfType<TType extends IncomingMessageType>(
  action: UnknownAction,
  type: TType
): action is PayloadAction<IncomingMessageOfType<TType>> {
  return incomingMessageReceived.match(action) && action.payload.result.type === type;
}
